import React from 'react'
import './scss/Banner.scss'

const Banner = (props) =>{
    return (
        <div className="banner">
            {props.children}
        </div>
    )
}

export default Banner